import { Tailwind, Html, Body, Button } from "@react-email/components"
import { Step, StepProduct } from "@components/configurator/ConfiguratorContext"
import { getPrice } from "@lib/swell/storefront-data-hooks/src/utils/product"
import { Selection } from "@components/ConfiguratorProductForm/ConfiguratorProductForm"

export async function sendEmail(
  props: any,
  title: string,
  currentFormattedTotalPrice: string,
  steps: Step[]
) {
  const { fullName, email, phone } = props
  return await fetch("/api/configurator/sendemail", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      fullName: fullName,
      email: email,
      title: title,
      currentFormattedTotalPrice: currentFormattedTotalPrice,
      steps: steps,
    }),
  })
}

export interface ConfiguratorEmailTemplateProps {
  fullName: string
  title: string
  currentFormattedTotalPrice: string
  steps: Step[]
}

export const ConfiguratorEmailTemplate: React.FC<ConfiguratorEmailTemplateProps> = ({
  fullName,
  title,
  currentFormattedTotalPrice,
  steps,
}: ConfiguratorEmailTemplateProps) => {
  return (
    <Tailwind>
      <Html lang="en" dir="ltr">
        <Body className="font-sans">
          <table className="border-0 w-full">
            <tr>
              <td></td>
              <td width="640">
                <div>
                  <div className="bg-slate-700 w-auto text-center p-2 ">
                    <a href="https://newwayvan.life/">
                      <img
                        src="https://cdn.builder.io/api/v1/image/assets%2F86c411b0ae7d404c8cdfbc782a799149%2F019b41496f844147bd24fc104a495f4c"
                        alt="New Way Van Life"
                        width="320px"
                      />
                    </a>
                  </div>

                  <p>
                    Dear {fullName},
                    <br />
                    <br />
                    Thank you for using our {title} to design your van conversion! Below is an
                    estimate based on the selections you made during the configuration process.
                    Please review the details carefully and feel free to reach out if you have any
                    questions or would like to make any changes.
                    <br />
                    <br />
                    Your Configured Van Features and Options:
                  </p>

                  <h1>{title}</h1>

                  <hr />

                  <div>
                    {steps.map((step, index) => {
                      return step?.stepProducts?.map((stepProduct: StepProduct, index) => {
                        return (
                          <>
                            <h3>{stepProduct?.product?.name}</h3>

                            {stepProduct.variant?.images[0]?.file?.url && (
                              <img width="640px" src={stepProduct.variant.images[0].file.url} />
                            )}

                            <table className="min-w-full border-collapse border border-solid border-slate-500">
                              <thead>
                                <tr>
                                  <th className="whitespace-nowrap py-3 px-4 text-left text-sm font-semibold text-gray-900 border border-solid border-slate-600">
                                    Option Name
                                  </th>
                                  <th className="whitespace-nowrap py-3 px-4 text-left text-sm font-semibold text-gray-900 border border-solid border-slate-600">
                                    Value
                                  </th>
                                  <th className="whitespace-nowrap py-3 px-4 text-left text-sm font-semibold text-gray-900 border border-solid border-slate-600">
                                    Price
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white">
                                <div>
                                  <tr>
                                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600">
                                      {stepProduct?.product?.name}
                                    </td>
                                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600">
                                      Base Price
                                    </td>
                                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600">
                                      {getPrice(
                                        stepProduct?.product?.price,
                                        stepProduct?.product?.currency || "USD"
                                      )}
                                    </td>
                                  </tr>
                                </div>

                                {stepProduct?.selections?.map((selection: Selection, index) => {
                                  if (!selection.includedInVariant) return <></>
                                  return (
                                    <>
                                      <div>
                                        <tr>
                                          <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600">
                                            {selection?.name}
                                          </td>

                                          {(() => {
                                            if (selection.isToggle) {
                                              if (selection.value === "") {
                                                return (
                                                  <>
                                                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600">
                                                      No
                                                    </td>
                                                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600"></td>
                                                  </>
                                                )
                                              } else {
                                                return (
                                                  <>
                                                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600">
                                                      Yes
                                                    </td>
                                                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600">
                                                      +{selection.priceForDisplay}
                                                    </td>
                                                  </>
                                                )
                                              }
                                            } else {
                                              if (selection.priceForDisplay === "Included") {
                                                return (
                                                  <>
                                                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600">
                                                      {selection.value}
                                                    </td>
                                                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600">
                                                      Included
                                                    </td>
                                                  </>
                                                )
                                              } else {
                                                return (
                                                  <>
                                                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600">
                                                      {selection.value}
                                                    </td>
                                                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600">
                                                      +{selection.priceForDisplay}
                                                    </td>
                                                  </>
                                                )
                                              }
                                            }
                                          })()}
                                        </tr>
                                      </div>
                                    </>
                                  )
                                })}

                                <div>
                                  <tr>
                                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600">
                                      <b>{stepProduct?.product?.name}</b>
                                    </td>
                                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600">
                                      <b>Total</b>
                                    </td>
                                    <td className="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900 border border-solid border-slate-600">
                                      <b>
                                        {getPrice(
                                          stepProduct?.variant?.price,
                                          stepProduct?.product?.currency || "USD"
                                        )}
                                      </b>
                                    </td>
                                  </tr>
                                </div>
                              </tbody>
                            </table>
                          </>
                        )
                      })
                    })}
                  </div>

                  <h2>Estimate: {currentFormattedTotalPrice}</h2>

                  <hr />

                  <p>
                    Please shoot us an email at support@newwayvan.life or give us a call for any
                    questions, additional information, or further van conversion kit customizations!
                  </p>

                  <p>
                    Best Regards,
                    <br />
                    NWVL Team
                    <br />
                    <br />
                    New Way Van Life
                    <br />
                    7564 Trade St, San Diego, CA 92121
                    <br />
                    hello@newwayvan.life
                    <br />
                    858-522-0162
                  </p>

                  <br />

                  <p className="text-[10px]">
                    <b>Disclaimer:</b>
                    <br />
                    The estimate provided is for informational purposes only and is subject to
                    change without notice. It represents an estimate of costs based on the options
                    selected and does not constitute a binding agreement or contract. New Way Van
                    Life, LLC reserves the right to adjust pricing and availability of options as
                    necessary.
                    <br />
                    <u>Estimate Accuracy:</u> The estimate is provided as an approximation of costs
                    and does not constitute a final quote. Actual costs may vary based on factors
                    such as taxes, fees, optional extras, and changes to specifications.
                    <br />
                    <u>Exclusions:</u> The estimate may not include taxes, registration fees,
                    delivery charges, optional extras, installation costs, warranties, service
                    plans, or other items not explicitly specified. Additional charges may apply for
                    customizations or features not included in the estimate.
                    <br />
                    <u>Product Representation:</u> All images and configurations shown in the
                    estimate are for illustrative purposes only. Actual products may vary in
                    appearance, specifications, and availability.
                    <br />
                    <u>Delivery Times:</u> Delivery times may vary based on product availability and
                    customization options. New Way Van Life, LLC will make reasonable efforts to
                    meet estimated delivery dates but does not guarantee delivery by a specific
                    date.
                    <br />
                    <u>Financing Options:</u> Financing options are available and subject to credit
                    approval. Terms and conditions apply. Please contact us for more information on
                    financing options.
                    <br />
                    <u>Terms and Conditions:</u> For additional information, please review the terms
                    and conditions found at{" "}
                    <a href="https://www.newwayvan.life/configurator-T-and-C/">
                      <u>NWVL Configurator Terms and Conditions</u>
                    </a>
                    . These terms and conditions outline important details regarding the estimate,
                    including limitations of liability, warranty disclaimers, and dispute resolution
                    procedures.
                  </p>
                </div>
              </td>
              <td></td>
            </tr>
          </table>
        </Body>
      </Html>
    </Tailwind>
  )
}

export default ConfiguratorEmailTemplate
